import React from "react";
import { FaUser, FaUserTag, FaToggleOn, FaCalendar } from "react-icons/fa";

const OrganizerDetailsCard = ({ formData }) => {

  const formatDate = (dateString) => {
    if (!dateString) return "Not available";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'short', 
        day: 'numeric' 
      });
    } catch (error) {
      return "Not available";
    }
  };


  return (
    <div className="viewing-organiser-card">
      <div className="viewing-organiser-card__header">
        <FaUser className="viewing-organiser-card__icon" />
        <h2 className="viewing-organiser-card__title">Account Information</h2>
      </div>
      <div className="viewing-organiser-card__body">
        <table className="viewing-organiser-table">
          <tbody>
            <tr className="viewing-organiser-table__label-row">
              <td className="viewing-organiser-table__label-cell">Full Name</td>
              <td className="viewing-organiser-table__value-cell">
                {formData.name || "Not provided"} {formData.title || ""}
              </td>
            </tr>
            <tr className="viewing-organiser-table__label-row">
              <td className="viewing-organiser-table__label-cell">Email</td>
              <td className="viewing-organiser-table__value-cell">
                {formData.email || "Not provided"}
              </td>
            </tr>
            <tr>
              <td className="viewing-organiser-table__label-cell">Phone</td>
              <td className="viewing-organiser-table__value-cell">
                {formData.cellNumber || "Not provided"}
              </td>
            </tr>
            <tr className="viewing-organiser-table__label-row">
              <td className="viewing-organiser-table__label-cell">User Role</td>
              <td className="viewing-organiser-table__value-cell">
                <span className={`role-badge ${formData.role}`}>
                  {formData.role || "Not specified"}
                </span>
              </td>
            </tr>
            <tr>
              <td className="viewing-organiser-table__label-cell">Account Status</td>
              <td className="viewing-organiser-table__value-cell">
                <span className={`status-badge ${formData.is_disabled ? 'status-disabled' : 'status-active'}`}>
                  {formData.is_disabled ? 'Disabled' : 'Active'}
                </span>
              </td>
            </tr>
            <tr className="viewing-organiser-table__label-row">
              <td className="viewing-organiser-table__label-cell">Member Since</td>
              <td className="viewing-organiser-table__value-cell">
                {formatDate(formData.created_at)}
              </td>
            </tr>
            <tr>
              <td className="viewing-organiser-table__label-cell">Last Updated</td>
              <td className="viewing-organiser-table__value-cell">
                {formatDate(formData.updated_at)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OrganizerDetailsCard;
